import React from "react";
import Slider from "@mui/material/Slider";

const min = 0;
const max = 100;

const marks = [
  {
    value: min,
    label: "Intensity",
  },
  {
    value: max,
    label: "100%",
  },
];

const ImageEditorSlider = (props) => {
  return (
    <Slider
      min={0}
      max={100}
      step={1}
      marks={marks}
      aria-label="Number Slider"
      valueLabelDisplay="auto"
      sx={{
        position: "absolute",
        color: "#FB4764",
        "& .MuiSlider-thumb": {
          backgroundColor: "#fff1f2",
          "&:before": {
            backgroundColor: "#FB4764",
          },
        },
        "& .MuiSlider-track": {
          backgroundColor: "#FB4764",
        },
        "& .MuiSlider-rail": {
          backgroundColor: "#b39ddb",
        },
        "& .MuiSlider-valueLabel": {
          backgroundColor: "#fff1f2",
          color: "#FB4764",
          borderRadius: "4px",
        },
        "& .MuiSlider-markLabel": {
          color: "#FB4764",
        },
      }}
      {...props}
    />
  );
};

export default ImageEditorSlider;
